import {
  DEFAULT_LANGUAGE,
  Language,
  REGISTERED_LANGUAGES
} from '../constants/i18n';

export function capitalize(str: string) {
  return `${str[0].toUpperCase()}${str.slice(1)}`;
}

export function toNonEmptyString(value: unknown): string | null {
  if (value == null) {
    return null;
  }
  const str = typeof value === 'number' ? String(value) : String(value).trim();
  return str.length > 0 ? str : null;
}

const isValidLanguage = (languageId: string): languageId is Language => {
  return REGISTERED_LANGUAGES.includes(languageId as Language);
};

export function normalizeLanguage(language?: string) {
  let normalizedLanguage = '';

  if (typeof language === 'string') {
    normalizedLanguage = language.replace('_', '-');
  }
  if (normalizedLanguage && isValidLanguage(normalizedLanguage)) {
    return normalizedLanguage;
  }

  return DEFAULT_LANGUAGE;
}
